import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerNavigateToLogin, registerResetAuthStatus, registerShowSessionExpiredNotification } from '../../utils/axiosConfig';
import { useAuth } from './AuthContext';
import { AuthStage } from './types';
import { useNotification } from '../Utils/NotificationContext';

/**
 * Komponente zur Registrierung der Weiterleitungsfunktion für 401-Fehler
 * Diese Komponente sollte in der App an einer hohen Stelle eingebunden werden
 */
const AuthRedirect: React.FC = () => {
    const navigate = useNavigate();
    const { resetAuth, setStage } = useAuth();
    const { showNotification } = useNotification();

    useEffect(() => {
        // Registriere die Navigations-Callback-Funktion
        registerNavigateToLogin(() => {
            navigate('/login', { replace: true });
        });

        // Registriere die Benachrichtigungsfunktion
        registerShowSessionExpiredNotification(() => {
            showNotification('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.', 'warning');
        });

        // Registriere die Auth-Reset-Funktion
        registerResetAuthStatus(async () => {
            // Auth-Status explizit auf EMAIL_INPUT setzen und lokale Daten löschen
            try {
                await resetAuth();
                setStage(AuthStage.EMAIL_INPUT);
                console.log('Auth-Status erfolgreich zurückgesetzt');
            } catch (error) {
                console.error('Fehler beim Zurücksetzen des Auth-Status:', error);
                // Trotzdem versuchen, den Status zurückzusetzen
                setStage(AuthStage.EMAIL_INPUT);
            }
        });
    }, [navigate, resetAuth, setStage]);

    // Keine Rendering-Ausgabe nötig
    return null;
};

export default AuthRedirect;
